/**
 * Auth endpoints — Google OAuth + /me.
 *
 * El refresh_token NO se maneja en JS: viaja por cookie httpOnly puesta por
 * el backend. Solo necesitamos guardar el access_token y mandarlo como Bearer.
 */
import { api, clearTokens, setToken } from "./client";

export interface TokenPair {
  access_token: string;
  refresh_token?: string | null;
  token_type: string;
}

export interface UserMe {
  id: number;
  email: string;
  name: string;
  handle: string | null;
  city: string | null;
  country: string;
  region: string | null;
  role: "user" | "admin" | "super_admin";
  avatar_color: string;
  initials: string;
  bio: string | null;
  verified: boolean;
  stars_avg: number;
  trades_completed: number;
  level: number;
  xp: number;
  created_at: string;
}

export async function fetchMe(): Promise<UserMe> {
  return api<UserMe>("/auth/me");
}

export interface UpdateMePayload {
  name?: string;
  handle?: string;
  city?: string;
  country?: string;
  region?: string;
  bio?: string;
  avatar_color?: string;
}

export async function updateMe(payload: UpdateMePayload): Promise<UserMe> {
  return api<UserMe>("/auth/me", {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function logout(): Promise<void> {
  // Best-effort: avisamos al backend para limpiar la cookie httpOnly. Si falla
  // (offline, 401), igual borramos el access del cliente.
  try {
    await api<void>("/auth/logout", { method: "POST" });
  } catch {
    // ignore
  }
  clearTokens();
}

// ---- Google OAuth ----

export interface GoogleUrlResponse {
  url: string;
  state: string;
}

export async function fetchGoogleAuthUrl(): Promise<GoogleUrlResponse> {
  return api<GoogleUrlResponse>("/auth/google/url");
}

export async function googleExchange(code: string, state?: string, expectedState?: string): Promise<TokenPair> {
  const tokens = await api<TokenPair>("/auth/google/exchange", {
    method: "POST",
    body: JSON.stringify({ code, state, expected_state: expectedState }),
  });
  setToken(tokens.access_token);
  return tokens;
}
